module.exports = __webpack_public_path__ + "img/card11.8b3ae238.png";